// Full-page handoff to the target realm's login (leaves the SPA into the BFF/
// Keycloak OIDC flow). The URL is BE-owned — workspace-check and verify-challenge
// both return the ready-to-use loginUrl. If BE later appends a login_hint, this
// stays unchanged.
export function redirectToUrl(url: string): void {
  // Defense-in-depth: only navigate to http(s) URLs. loginUrl is BE-owned, but
  // this guards against a javascript:/data: value ever slipping through.
  if (/^https?:\/\//i.test(url)) {
    window.location.assign(url);
  }
}
